<div id="embedded-area" class="embedded-area" *ngIf="!done && !usedUrl">

</div>

<div class="message" *ngIf="usedUrl">
	The link has expired.
	<br />Please close this window and generate a new signature request.
</div>

<div class="message" *ngIf="done">
	Your request has been sent.
	<br />
	<span *ngIf="!isRequest">You may close this window and return to Procore.</span>
	<span *ngIf="isRequest">You may close this window and track the request directly in Dropbox Sign.</span>
</div>